import React, { useEffect, useState } from 'react';
import { array, func } from 'prop-types';

import TreeMenu from 'react-simple-tree-menu';

import classes from './TreeMenuWrapper.module.css';

const DEFAULT_PADDING = 16;
const ICON_SIZE = 8;
const LEVEL_SPACE = 16;

const toggleAction = props => {
    props.onToggleItem(props);

    if (props.toggleNode) {
        props.toggleNode();
    }
};

const ToggleIcon = ({ on, onClick }) => (
    <span
        role="none"
        onClick={onClick}
        className={classes.toggleIcon}
    >
        {on ? <i className="fas fa-caret-down" /> : <i className="fas fa-caret-right" />}
    </span>
);

const FlavorIcon = ({type, style}) => {
    switch (type) {
        case 'campus':
            return (
                <img
                    src="/assets/images/campusTreeIcon.svg"
                    alt="campus icon"
                    style={style}
                    className={classes.flavorIcon}
                />
            );
        case 'company':
            return (
                <img
                    src="/assets/images/companyTreeIcon.svg"
                    alt="company icon"
                    style={style}
                    className={classes.flavorIcon}
                />
            );
        case 'client':
            return (
                <img
                    src="/assets/images/clientTreeIcon.svg"
                    alt="client icon"
                    style={style}
                    className={classes.flavorIcon}
                />
            );
        case 'site':
            return (
                <img
                    src="/assets/images/siteTreeIcon.svg"
                    alt="site icon"
                    style={style}
                    className={classes.flavorIcon}
                />
            );
        case 'area':
        case 'areaItem':
            return (
                <img
                    src="/assets/images/areaTreeIcon.svg"
                    alt="area icon"
                    style={style}
                    className={classes.flavorIcon}
                />
            );
        case 'equipment':
        case 'equipmentItem':
            return (
                <img
                    src="/assets/images/equipmentTreeIcon.svg"
                    alt="equipment icon"
                    style={style}
                    className={classes.flavorIcon}
                />
            );
        case 'system':
        case 'systemItem':
            return (
                <img
                    src="/assets/images/systemTreeIcon.svg"
                    alt="system icon"
                    style={style}
                    className={classes.flavorIcon}
                />
            );
        default:
            return null;
    }
};

const ListItem = (props) => {
    return (
        <li
            role="none"
            style={{ paddingLeft: DEFAULT_PADDING + ICON_SIZE + props.level * LEVEL_SPACE, cursor: 'pointer' }}
            onClick={() => {
                props.setProgressBarLoading(true);
                props.setActiveNode(props);
                props.onClickItem(props);
            }}
            className={props.id === props.activeNode.id ? classes.active : ''}
        >
            {props.hasNodes &&
            <React.Fragment>
                <ToggleIcon
                    on={props.isOpen}
                    onClick={() => { toggleAction(props); }}
                />
                <FlavorIcon type={props.type} />
            </React.Fragment>
            }
            {!props.hasNodes &&
            <FlavorIcon
                type={props.type}
                style={{
                    marginLeft: '1.3rem'
                }}
            />}
            <span>{props.label}</span>
        </li>
    );
};

const TreeMenuWrapperList = ({
    items,
    onClickItem,
    onToggleItem,
    reset,
    saveTreeReset,
    setProgressBarLoading,
    ...props
}) => {
    const [activeNode, setActiveNode] = useState({});

    useEffect(() => {
        saveTreeReset(reset);
    }, []);

    return (
        <ul>
            {
                items.map(props => (
                    <ListItem
                        onToggleItem={onToggleItem}
                        onClickItem={onClickItem}
                        setActiveNode={setActiveNode}
                        activeNode={activeNode}
                        setProgressBarLoading={setProgressBarLoading}
                        {...props}
                    />
                ))
            }
        </ul>
    );
};

const TreeMenuWrapper = ({ data, ...props }) => {
    if (!data.length) {
        return null;
    }

    return (
        <TreeMenu
            hasSearch={false}
            data={data}
            initialOpenNodes={[data[0].id]}
        >
            { ({ items, reset }) => (
                <TreeMenuWrapperList
                    items={items}
                    reset={reset}
                    {...props}
                />
            )}
        </TreeMenu>
    );
};

TreeMenuWrapper.defaultProps = {
    data:         [],
    onClickItem:  () => {},
    onToggleItem: () => {}
};

TreeMenuWrapper.propTypes = {
    data:         array.isRequired,
    onClickItem:  func.isRequired,
    onToggleItem: func.isRequired
};

export default TreeMenuWrapper;
